// Activity-weighted creator leaderboard + the viewer's own rank.
import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export type LeaderboardPeriod = "week" | "all";

export interface LeaderboardRow {
  rank: number;
  user_id: string;
  display_name: string;
  score: number;
  tryons: number;
  aura: number;
  likes: number;
  featured: number;
  is_self: boolean;
}

export interface SelfRank {
  rank: number;
  total: number;
  score: number;
  tryons: number;
  aura: number;
  likes: number;
  featured: number;
  display_name: string;
}

export function useCreatorLeaderboard(period: LeaderboardPeriod, enabled = true) {
  const [rows, setRows] = useState<LeaderboardRow[]>([]);
  const [self, setSelf] = useState<SelfRank | null>(null);
  const [loading, setLoading] = useState(enabled);

  const reload = useCallback(async () => {
    setLoading(true);
    const [topRes, selfRes] = await Promise.all([
      supabase.rpc("get_creator_leaderboard", { _period: period, _limit: 20 }),
      supabase.rpc("get_self_leaderboard_rank", { _period: period }),
    ]);
    setRows((topRes.data ?? []) as LeaderboardRow[]);
    const sr = (selfRes.data ?? [])[0] as SelfRank | undefined;
    setSelf(sr ?? null);
    setLoading(false);
  }, [period]);

  useEffect(() => {
    if (!enabled) return;
    void reload();
  }, [enabled, reload]);

  return { rows, self, loading, reload };
}
